import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPartnerDetails } from "../../slices/partner/action";
import { formatDate } from "../../helpers/formatDate";

const Rewards = () => {
  const dispatch = useDispatch();
  const { partnerDetails } = useSelector((state) => state.partner);

  useEffect(() => {
    if (!partnerDetails) {
      getPartnerDetailsFunc();
    }
  }, []);

  const getPartnerDetailsFunc = async () => {
    try {
      await getPartnerDetails({}, dispatch);
    } catch (error) {}
  };

  return (
    <div className="page-content px-4 pb-0">
      <div className="row">
        <div className="col-md-12 m-auto">
          <div
            style={{ backdropFilter: " blur(4px)" }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4"
          >
            <h4 className="mb-0">Rewards</h4>
          </div>

          <div className="table-responsive position-relative d-flex flex-column">
            <table className="table table-nowrap table-centered align-middle mb-0">
              <thead className="bg-light text-muted fs-14">
                <tr>
                  <th></th>
                  <th>Reward Type</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody className="fs-13">
                {partnerDetails?.rewards?.map((reward) => {
                  return (
                    <tr>
                      <td>
                        <a href="#" className="text-muted cursor-grab d-block">
                          <i className="bx bx-grid-vertical fs-18 text-muted"></i>
                        </a>
                      </td>
                      <td>
                        <strong>{reward?.rewardTypeId}</strong>
                      </td>
                      <td>{formatDate(reward?.createdAt)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rewards;
